import React, { useContext, useEffect, useState } from 'react'
import { Button, Col, Form, Row, Spinner } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import { add_tags, update_tags } from '../../../../Controller/actions';
import { NewContext } from '../../../../Context/NewContext';

import './themetagsform.css';

export const TagsForm = ({ title }) => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { isLoading, setIsLoading, validated, setValidated, updatedData, setUpdatedData } = useContext(NewContext);
    const [tags, setTags] = useState({
        name: state ? state.name : "",
        isActive: state ? state.isActive == undefined ? false : state.isActive : false,
    });

    const handleChange = (e) => {
        setUpdatedData({ ...updatedData, [e.target.name]: e.target.name === 'name' ? e.target.value.replace(/\s+/g, '').toLowerCase() : e.target.value })
        setTags({ ...tags, [e.target.name]: e.target.name === 'name' ? e.target.value.replace(/\s+/g, '').toLowerCase() : e.target.value });
    };

    let handleSwitch = (e) => {
        setUpdatedData({ ...updatedData, [e.target.name]: tags[e.target.name] ? false : true });
        setTags({ ...tags, [e.target.name]: tags[e.target.name] ? false : true });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            e.preventDefault();
            e.stopPropagation();
            setValidated(true);
            return;
        };
        let createUpdateTags;
        setIsLoading(true);
        if (state) {
            createUpdateTags = await update_tags(updatedData, state._id)
        } else {
            createUpdateTags = await add_tags(tags)
        }
        setIsLoading(false);
        if (createUpdateTags) {
            const { message, status } = createUpdateTags;
            if (status) {
                toast.success(message);
                navigate("/themetags");
                setTags({
                    name: "",
                    isActive: false,
                });
                setUpdatedData({});
                setValidated(false);
            } else {
                toast.error(message);
            };
        }

        // var allFieldDone = [];

        // Object.keys(tags).map(async (fieldName, i) => {
        //     if (fieldName !== 'id') {
        //         if (tags[fieldName].toString().length > 0) {
        //             allFieldDone.push(true);
        //         } else {
        //             allFieldDone.push(false);
        //             toast.error(`${fieldName.charAt(0).toUpperCase() + fieldName.slice(1)} is Requied!`);
        //         }
        //     }
        // });

        // const aalFieldDone = allFieldDone.every((val, i, arr) => val === true)
        // if (aalFieldDone) {
        //     let createUpdateTags;
        //     setIsLoading(true);
        //     if (state) {
        //         createUpdateTags = await update_tags(tags, state._id)
        //     } else {
        //         createUpdateTags = await add_tags(tags)
        //     }
        //     setIsLoading(false);
        //     if (createUpdateTags) {
        //         const { message, status } = createUpdateTags;
        //         if (status) {
        //             toast.success(message);
        //             navigate("/themetags");
        //             setTags({
        //                 name: "",
        //                 isActive: false,
        //             });
        //         } else {
        //             toast.error(message);
        //         };
        //     }
        // }
    };

    useEffect(() => {
        document.title = `Emoji Keyboard | ${title}`;
        setUpdatedData({});
    }, []);

    return (
        <div className='addslider-main p-3'>
            <div className='sliders-header mb-3 d-flex justify-content-between'>
                <h3>{state ? `Edit Tags` : `Add Tags`}</h3>
            </div>
            <Row>
                <Col md={8} lg={9}>
                    <Form noValidate validated={validated} onSubmit={handleSubmit} method="POST">
                        <Row className='mb-3'>
                            <Col lg={12} className="mb-3">
                                <Row>
                                    <Form.Label htmlFor='tags_name' column md={3} sm={4}>Name</Form.Label>
                                    <Col><Form.Control id='tags_name' type="text" placeholder="Enter name" name='name' onChange={handleChange} value={updatedData.name ? updatedData.name : tags.name} required /></Col>
                                </Row>
                            </Col>
                            {
                                state &&
                                <Col lg={12} className="mb-3">
                                    <Row className='align-items-center'>
                                        <Form.Label htmlFor='tags_isActive' column md={3} sm={4}>Active</Form.Label>
                                        <Col><Form.Check type="switch" id="tags_isActive" name='isActive' onChange={handleSwitch} checked={updatedData.isActive ? updatedData.isActive : tags.isActive} role="button" /></Col>
                                    </Row>
                                </Col>
                            }
                        </Row>
                        <Row className='justify-content-end'>
                            <Col lg={12}>
                                <Row className='align-items-center'>
                                    <Col lg={3} md={3} sm={4}></Col>
                                    <Col>
                                        <Button variant="primary" type="submit" className='px-5 me-3' style={{ width: "150px" }}>
                                            {isLoading ? <Spinner animation="border" size="sm" /> : state ? `Update` : `Submit`}
                                        </Button>
                                        <Button variant="danger" className='w-auto px-5' onClick={() => navigate(-1)}>{`Back`}</Button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
        </div>
    )
};

TagsForm.defaultProps = {
    title: "Tags Form"
};

export default TagsForm;